function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(-2417 -2023)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 143"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 138"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 137"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse 45"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#menu_crcl_b_path0_fill",
  transform: "translate(2417 2023)",
  fill: "#4D9ADF"
})))), /*#__PURE__*/React.createElement("g", {
  id: "minus"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path 24"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#menu_crcl_b_path1_fill",
  transform: "translate(2425.89 2042.03)",
  fill: "#FFFFFF"
})))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "menu_crcl_b_path0_fill",
  d: "M 20 40C 31.0457 40 40 31.0457 40 20C 40 8.9543 31.0457 0 20 0C 8.9543 0 0 8.9543 0 20C 0 31.0457 8.9543 40 20 40Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "menu_crcl_b_path1_fill",
  d: "M 20.769 0L 0.769 0C 0.565049 3.55271e-15 0.36945 0.0810195 0.225235 0.225235C 0.0810195 0.36945 3.55271e-15 0.565048 1.77636e-15 0.768999C 3.55271e-15 0.972951 0.0810195 1.16855 0.225235 1.31277C 0.36945 1.45698 0.565049 1.538 0.769 1.538L 20.769 1.538C 20.973 1.538 21.1685 1.45698 21.3128 1.31277C 21.457 1.16855 21.538 0.972951 21.538 0.768999C 21.538 0.565048 21.457 0.36945 21.3128 0.225235C 21.1685 0.0810195 20.973 3.55271e-15 20.769 0Z"
}));

function SvgMinuscircleblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinuscircleblue);
export default __webpack_public_path__ + "static/media/minuscircleblue.3b4b16fb.svg";
export { ForwardRef as ReactComponent };